import {ViewportScroller} from '@angular/common';
import {
  AfterViewInit,
  Component,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import {Observable, takeUntil} from 'rxjs';
import {OnDestroySubject, ProductComponent} from '../../data/model';
import {ServiceOfferFormComponent} from './components/service-offer-form';
import {ServiceOfferStore, ServiceOfferViewModel} from './service-offer.store';

@Component({
  selector: 'app-service-offer',
  templateUrl: './service-offer.component.html',
  styleUrls: ['./service-offer.component.scss'],
  host: {class: 'app-service-offer'},
  providers: [ServiceOfferStore],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ServiceOfferComponent
  extends OnDestroySubject
  implements ProductComponent, AfterViewInit
{
  @ViewChild('offerForm', {static: false})
  offerFormComponent: ServiceOfferFormComponent;
  formToDisplay$: Observable<string>;
  vm$: Observable<ServiceOfferViewModel>;

  constructor(
    private serviceOfferStore: ServiceOfferStore,
    private viewPortScroller: ViewportScroller,
  ) {
    super();
    this.vm$ = this.serviceOfferStore.vm$;
    this.formToDisplay$ = this.serviceOfferStore.formToDisplay$;
  }

  next(): void {
    this.offerFormComponent.markAllAsTouched();
    if (!this.offerFormComponent.valid()) {
      return;
    }
    this.viewPortScroller.scrollToAnchor('layout-header');

    this.serviceOfferStore.continue({
      selected: this.offerFormComponent.addonSelected(),
      item: this.offerFormComponent.value(),
    });
  }

  complete(): void {
    this.offerFormComponent.markAllAsTouched();
    if (!this.offerFormComponent.valid()) {
      return;
    }

    this.serviceOfferStore.complete({
      selected: this.offerFormComponent.addonSelected(),
      item: this.offerFormComponent.value(),
    });
  }

  registerAnotherPerson(): void {
    this.offerFormComponent.markAllAsTouched();
    if (!this.offerFormComponent.valid()) {
      return;
    }

    this.serviceOfferStore.registerAnotherPerson({
      selected: this.offerFormComponent.addonSelected(),
      item: this.offerFormComponent.value(),
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.serviceOfferStore.cartItem$.subscribe(item => {
        this.offerFormComponent.bindFormValue(!!item, item);
      });
      this.offerFormComponent?.offerForm.statusChanges
        .pipe(takeUntil(this.onDestroy))
        .subscribe(status => {
          this.serviceOfferStore.setFormValidity(status === 'VALID');
        });
      this.serviceOfferStore.setFormValidity(
        this.offerFormComponent?.offerForm.status === 'VALID',
      );
    });
  }

  valid(): boolean {
    throw new Error('Method not implemented.');
  }
}
